interface Environment {
  production: boolean;
  /** Overige Holli REST API (bijv. replies) onder `/api` */
  apiBaseUrl: string;
  /** Outlook add-in: office-login, mailbox discovery, Graph webhook-base — prefix `/outlook` */
  outlookApiBaseUrl: string;
}

export const environment: Environment = {
  production: false,
  apiBaseUrl: 'https://app.test.holli.nl/api',
  outlookApiBaseUrl: 'https://app.test.holli.nl/outlook',
};
